const connects = (state = null, action) => {
  const { payload, type } = action;

  switch (type) {
    case 'INITIAL_DATA':
      return payload.connects || [];

    case 'SET_CONNECTS':
      return payload;

    case 'NEW_CONNECT':
      return [payload, ...state].filter((x) => x._id !== payload._id);

    case 'ACCEPT_CONNECTS':
      return state.map((x) => {
        if (!payload.connectIds.includes(x._id)) return x;

        return { ...x, status: 'accepted' };
      });

    case 'REFUSE_CONNECTS':
      return state.map((x) => {
        if (!payload.connectIds.includes(x._id)) return x;

        return { ...x, status: 'rejected' };
      });

    case 'NEW_NOTIFICATION':
      if (!payload.connectData) return state;

      return [payload.connectData, ...state.filter((x) => x._id !== payload.connectData._id)];

    case 'UPDATE_CONNECT_STATUS':
      return state.map((x) => {
        if (x._id !== payload.connectId) return x;

        return {
          ...x,
          status: payload.status,
          canceledBy: payload.canceledBy || x.canceledBy
        };
      });

    case 'LOGOUT':
      return null;

    default:
      return state;
  }
};

export default connects;
